module.exports = __webpack_public_path__ + "static/img/icon-pin-fill.77ff1365.svg";